import React, { useEffect, useRef } from 'react';
import { useNavigate, Outlet, useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../hooks/storeHooks';

import './PageLayout.css';

// import NavigationBar from '../features/navigation/components/NavigationBar';
import '../styles/darktheme/style.scss';
import UserService from '../services/user/user.service';
import FooterBar from './FooterBar';

import './PageLayout.css';
import '../styles/darktheme/style.scss';
import { updateSelectedAsset } from './../features/navigation/AssetGroupsSlice';
import { fetchInitialStateAsync } from './../features/navigation/AssetGroupsSlice';
import { setIndustryApplicationId } from './../features/asset-analysis/AssetAnalysisSlice';
import { fetchNotificationsAsync } from './../features/navigation/NotificationsSlice';
import AllyNavigation from '../features/navigation/components/AllyNavigation';
import WellScanMonitor from '../features/custom-views/MultiWellControlConfirm/WellScanMonitor';

export const Layout = () => {
  const themeMode = useAppSelector((state) => state.theme.mode);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const assets = useAppSelector((state) => state.assetGroups?.assets);
  const selectedGroup = useAppSelector((state) => state.assetGroups?.selectedGroup);

  const { assetId, assetGroupName, groupName } = useParams();
  const groupHashMap = useAppSelector((state) => state.assetGroups.groupHashMap);

  const notificationPromiseRef = useRef<any>(null);

  useEffect(() => {
    if (location.pathname === '/') {
      UserService.getLandingPage().then((response) => {
        if (response) {
          const landingPage = JSON.parse(JSON.stringify(response));

          landingPage.PageType === 'Group'
            ? navigate('/group/status/' + (landingPage.Value as string))
            : navigate(
                '/asset/status/' +
                  (landingPage.Value.split('|')[1] as string) +
                  '/' +
                  (landingPage.Value.split('|')[0] as string),
              );
        }
      });
    }
  }, []);

  useEffect(() => {
    const currentGroupName = assetGroupName ? assetGroupName : (groupName ?? '');
    if (assets && (assetGroupName || groupName)) {
      const formattedGroupName = currentGroupName.split('_').join(' ');
      const mergedGroups = Object.values(groupHashMap);
      const selectedGroup = mergedGroups.find((group) => group.assetGroupName === formattedGroupName);
      const selectedAsset = selectedGroup?.assets.find(
        (asset) => asset.assetId?.toLowerCase() === assetId?.toLowerCase(),
      );
      if (selectedGroup || selectedAsset) {
        dispatch(
          updateSelectedAsset({
            groupId: Number(selectedGroup?.id),
            assetId: selectedAsset?.assetName,
            searchString: undefined,
            assetIdGuid: selectedAsset?.assetId,
          }),
        );

        if (selectedAsset) {
          // Cancel previous notification request if it exists
          if (notificationPromiseRef.current) {
            notificationPromiseRef.current.abort();
          }

          // Create new request and store the promise for cancellation
          notificationPromiseRef.current = dispatch(
            fetchNotificationsAsync({
              type: 'asset',
              id: assetId || '',
              notificationTypeId: '',
            }),
          );

          notificationPromiseRef.current.catch((error: any) => {
            if (error.name !== 'AbortError') {
              console.error('Asset notification request failed:', error);
            }
          });

          dispatch(setIndustryApplicationId({ industryApplicationId: selectedAsset.industryApplicationId }));
        }
      }
    } else {
      if (currentGroupName) {
        // Cancel previous notification request if it exists
        if (notificationPromiseRef.current) {
          notificationPromiseRef.current.abort();
        }

        // Create new request and store the promise for cancellation
        notificationPromiseRef.current = dispatch(
          fetchNotificationsAsync({ type: 'group', id: currentGroupName })
        );

        notificationPromiseRef.current.catch((error: any) => {
          if (error.name !== 'AbortError') {
            console.error('Group notification request failed:', error);
          }
        });
      }
      if (!assets) {
        dispatch(fetchInitialStateAsync());
      }
    }

    // Cleanup function to cancel requests when dependencies change or component unmounts
    return () => {
      if (notificationPromiseRef.current) {
        notificationPromiseRef.current.abort();
      }
    };
  }, [selectedGroup, assets, dispatch, assetGroupName, groupName, assetId]);

  return (
    <div className={`outer-container ${themeMode === 'dark' ? 'theme-dark' : ''}`}>
      {/* <div className='navbar-container'> */}
      <WellScanMonitor />
      <AllyNavigation />
      {/* </div> */}
      <div className='outlet-container'>
        <div className='flex h-full flex-column'>
          <Outlet />
        </div>
        <FooterBar />
      </div>
    </div>
  );
};
